module.exports = __webpack_public_path__ + "assets/16f7875557b3f8bbb55b66e914ecb260.png";